"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _theme = require("HubStyleTokens/theme");

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _BrowserTest = require("../utils/BrowserTest");

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.25em;\n  width: 4.5em;\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  background-color: currentColor;\n  color: ", ";\n  border-radius: 50%;\n  height: 1em;\n  width: 1em;\n  animation: ", ", ", ";\n  animation-duration: 1s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n\n  &:not(:last-child) {\n    margin-right: 0.75em;\n  }\n  &:nth-child(2) {\n    animation-delay: -0.66s;\n  }\n  &:nth-child(3) {\n    animation-delay: -0.33s;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    0%, 100% {\n      top: 0;\n    }\n\n    25% {\n      top: .25em;\n    }\n\n    50% {\n      top: 0\n    }\n\n    75% {\n      top: -.25em;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  0%, 100% {\n    transform: translateY(0);\n  }\n\n  25% {\n    transform: translateY(.25em);\n  }\n\n  50% {\n    transform: translateY(0);\n  }\n\n  75% {\n    transform: translateY(-.25em);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  25% {\n    background-color: ", ";\n  }\n  75% {\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var loadingColorAnimation = (0, _styledComponents.keyframes)(_templateObject(), _theme.LOADING_INACTIVE_COLOR, _theme.LOADING_INACTIVE_COLOR);
var loadingAnimation = (0, _styledComponents.keyframes)(_templateObject2());

if ((0, _BrowserTest.isIE11)()) {
  // Fix for #5734
  loadingAnimation = (0, _styledComponents.keyframes)(_templateObject3());
}

var Dot = _styledComponents.default.div.withConfig({
  displayName: "UILoadingDots__Dot",
  componentId: "z4m1pd-0"
})(_templateObject4(), _theme.LOADING_DEFAULT_COLOR, loadingAnimation, loadingColorAnimation);

var LoadingDots = _styledComponents.default.div.withConfig({
  displayName: "UILoadingDots__LoadingDots",
  componentId: "z4m1pd-1"
})(_templateObject5(), function (props) {
  return props.grow && "width: 100%; height: 100%;";
});

var warnForProps = function warnForProps(props) {
  if (props.use || props.color) {
    _devLogger.default.warn({
      message: '[UILoadingDots]: the `use` and `color` props have been removed.',
      key: 'UILoadingDots - calypso only',
      url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6039'
    });
  }
};

var getTranslatedTitle = function getTranslatedTitle() {
  return _I18n.default.fired && _I18n.default.fired.ready ? _I18n.default.text('salesUI.UILoading.title') : '';
};

var getClassName = function getClassName(className, grow) {
  return (0, _classnames.default)(className, 'uiLoading', {
    'uiLoading-grow': grow
  });
};

var getStyle = function getStyle(minHeight, style) {
  return minHeight ? (0, _extends2.default)({}, style, {
    minHeight: minHeight
  }) : style;
};

var _default = _react.default.createClass({
  displayName: "UILoadingDots",
  propTypes: {
    grow: _propTypes.default.bool.isRequired,
    minHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    title: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      grow: true,
      title: getTranslatedTitle
    };
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        __color = _this$props.color,
        grow = _this$props.grow,
        minHeight = _this$props.minHeight,
        style = _this$props.style,
        title = _this$props.title,
        __use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "color", "grow", "minHeight", "style", "title", "use"]);
    warnForProps(this.props);
    return _react.default.createElement(LoadingDots, (0, _extends2.default)({
      className: getClassName(className, grow),
      "data-loading": true,
      style: getStyle(minHeight, style),
      title: (0, _lazyEval.default)(title),
      grow: grow
    }, rest), _react.default.createElement(Dot, {
      className: "uiLoadingDot dot-1"
    }), _react.default.createElement(Dot, {
      className: "uiLoadingDot dot-2"
    }), _react.default.createElement(Dot, {
      className: "uiLoadingDot dot-3"
    }));
  }
});

exports.default = _default;
module.exports = exports.default;